import { defineMessages } from 'react-intl';

export const scope = 'app.components.KamereoProductSection';

export default defineMessages({
  freshDescription: {
    id: `${scope}.freshDescription`,
    defaultMessage:
      'Rau củ organic từ nông trại Đà Lạt, thu hoạch mỗi sáng, giao tận bếp trước 6h. Chất lượng kiểm định, giá B2B không qua trung gian.',
  },
  freshTag1: {
    id: `${scope}.freshTag1`,
    defaultMessage: 'Nguồn gốc Đà Lạt',
  },
  freshTag2: {
    id: `${scope}.freshTag2`,
    defaultMessage: 'Kiểm định chất lượng',
  },
  exploreCta: {
    id: `${scope}.exploreCta`,
    defaultMessage: 'Khám phá',
  },
});
